import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: CommonState = {
  separator: ''
};

export interface CommonState {
  separator: string;
}

export const slice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setSeparator: (state, action: PayloadAction<string>) => {
      state.separator = action.payload;
    }
  }
});

export default slice.reducer;
export const { setSeparator } = slice.actions;